module.exports = __webpack_public_path__ + "static/media/img_landing01.e7ffaa82.png";